/**
 * 小于10补0
 */
export function patchZero(number: number) {
  return number < 10 && number >= 0 ? `0${number}` : number
}
/**
 * 将日期转换为毫秒数
 * @param currentDate 日期（YYYY-MM-DD，YYYY/MM/DD，YYYY-MM-DD HH:mm:ss，YYYY/MM/DD HH:mm:ss）
 */
export function getTimeByDate(currentDate: string) {
  const reg1 = /^\d{4}(-|\/)\d{2}(-|\/)\d{2}$/
  const reg2 = /^\d{4}(-|\/)\d{2}(-|\/)\d{2}\s\d{2}:\d{2}:\d{2}$/
  const dateReg = /\d{4}|\d{2}/g
  const dateArr = currentDate?.match(dateReg) || []
  if (reg1.test(currentDate) || reg2.test(currentDate)) {
    return new Date(
      Number(dateArr[0]),
      Number(dateArr[1]) - 1,
      Number(dateArr[2]),
      Number(dateArr[3]) || 0,
      Number(dateArr[4]) || 0,
      Number(dateArr[5]) || 0,
    ).getTime()
  } else {
    return null
  }
}
/**
 * 将毫秒数转换为日期
 * @param time 毫秒数
 * @param format 日期格式
 */
export function getDateByTime(time: number, format?: string) {
  const date = new Date(time)
  return getFormatDate(date, format) // 获取格式化日期
}
/**
 * 获取格式化日期
 * @param currentDate 日期
 * @param format 日期格式（YYYY，YYYY-MM-DD，YYYY/MM/DD，YYYY-MM-DD HH:mm:ss，YYYY/MM/DD HH:mm:ss）
 */
export function getFormatDate(currentDate: Date, format?: string) {
  const reg_delimiter = /-|\//g
  const delimiter = format?.match(reg_delimiter)?.[0] || "-" // 分隔符
  const year = currentDate.getFullYear()
  const month = currentDate.getMonth() + 1
  const date = currentDate.getDate()
  const hh = currentDate.getHours()
  const mm = currentDate.getMinutes()
  const ss = currentDate.getSeconds()
  if (!format || format === "YYYY-MM-DD" || format === "YYYY/MM/DD") {
    return `${year}${delimiter}${patchZero(month)}${delimiter}${patchZero(date)}`
  } else if (format === "YYYY-MM-DD HH:mm:ss" || format === "YYYY/MM/DD HH:mm:ss") {
    return `${year}${delimiter}${patchZero(month)}${delimiter}${patchZero(date)} ${patchZero(
      hh,
    )}:${patchZero(mm)}:${patchZero(ss)}`
  } else if (format === "YYYY") {
    return `${year}`
  } else if (format === "YYYY-MM" || format === "YYYY/MM") {
    return `${year}${delimiter}${patchZero(month)}`
  } else {
    return null
  }
}
/**
 * 获取指定日期之前或之后n天的日
 * @param currentDate 指定日期（支持字符串及Date类型）
 * @param dayNumber 天数（正数表示之后，负数表示之前）
 * @param format 日期格式
 */
export function getPrevOrNextDate(currentDate: string | Date, dayNumber: number, format?: string) {
  let dateTime
  if (typeof currentDate === "string") {
    dateTime = getTimeByDate(currentDate) // 将日期转换为毫秒数
  } else if (currentDate instanceof Date) {
    dateTime = currentDate.getTime()
  }
  if (dateTime) {
    const calculated = dateTime + 60 * 60 * 1000 * 24 * dayNumber
    return getDateByTime(calculated, format) // 将毫秒数转换为日期
  } else {
    return null
  }
}
